// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"DigitalWizardPageWithTitleTemplate_themeRoot__3hkUJ","wizardContainer":"DigitalWizardPageWithTitleTemplate_wizardContainer__2CN6A"};